/** Whether the open project is saved - one small pill, the same in every workspace. */

import clsx from 'clsx';

export function SaveState({ isSaving, isDirty }: { isSaving: boolean; isDirty: boolean }) {
  const label = isSaving ? 'Saving…' : isDirty ? 'Unsaved changes' : 'Saved';
  return (
    <span
      className={clsx(
        'inline-flex shrink-0 items-center gap-1.5 rounded-full px-2 py-0.5 text-[11px] font-medium',
        isSaving || isDirty ? 'bg-amber-50 text-amber-800' : 'bg-green-50 text-green-800',
      )}
    >
      <span aria-hidden="true" className={clsx('h-1.5 w-1.5 rounded-full', isSaving || isDirty ? 'bg-amber-500' : 'bg-green-600')} />
      {label}
    </span>
  );
}
